export const setShopDetailsToLocalStorage = (data) => {
	localStorage.setItem("shopDetails", JSON.stringify(data));
};

export const getShopDetailsFromLocalStorage = () => {
	return localStorage.getItem("shopDetails")
		? JSON.parse(localStorage.getItem("shopDetails"))
		: {};
};
